<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image" />
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">{{ profile()?.designation }}</h1>
      <ul>
        <li>
          <a class="active" [routerLink]="['/']">Home</a>
        </li>
        <li>
          <a>About</a>
        </li>
        <li>{{ profile()?.name }}</li>
      </ul>
    </div>
  </div>

  <div *ngIf="profile()" class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 director-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <about-menu></about-menu>
        </div>

        <div class="col-lg-8">
          <section class="profile-section orange-color">
            <div class="container">
              <div class="row clearfix">
                <!-- Image Section -->
                <div class="image-column col-lg-5 md-mb-50">
                  <div class="inner-column mb-50 md-mb-0">
                    <div class="image">
                      <img [src]="profile()?.profileImage" [alt]="profile()?.name || ''" class="img-fluid" />
                    </div>
                    <div class="team-content text-center">
                      <h3>{{ profile()?.name }}</h3>
                      <h4>{{ profile()?.qualification }}</h4>
                      <div class="text">{{ profile()?.designation }}</div>
                    </div>
                  </div>
                </div>
                <!-- Content Section -->
                <div class="content-column col-lg-7 md-pl-15 md-pt-0">
                  <div class="inner-column">
                    <h2>{{ profile()?.name }}</h2>
                    <h4>{{ profile()?.qualification }}</h4>
                    <h4>{{ profile()?.designation }}</h4>
                    <p *ngFor="let description of profile()?.descriptions | slice:0:2">
                      {{ description }}
                    </p>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="content-part">
                    <div class="blog-desc row" *ngFor="let description of profile()?.descriptions | slice:2">
                      <p>{{ description }}</p>
                    </div>
                    <div class="blog-desc row" *ngFor="let desc of profile()?.additionalDescriptions">
                      <p>{{ desc }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12" *ngIf="profile()?.message">
                  <h2 class="blog-title">{{ profile()?.message?.title }}</h2>
                  <blockquote>
                    <div class="founder-message">
                      <p *ngIf="profile()?.message?.greeting">{{ profile()?.message?.greeting }}</p>
                      <div>&nbsp;</div>
                      <p *ngFor="let para of profile()?.message?.paragraphs">{{ para }}</p>
                      <div>&nbsp;</div>
                      <p *ngIf="profile()?.message?.closing">{{ profile()?.message?.closing }}</p>

                      <p class="message-sign">{{ profile()?.message?.sign }}</p>
                      <p class="message-sign" *ngIf="profile()?.message?.title_sign">{{ profile()?.message?.title_sign }}</p>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
